<template>
  <div>
    <div class="recordBox comStyBox">
      <yNavBar :title="title" />
      <div class="contentbox">
        <div class="content-wrapper" v-html="infocontent"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getXieYiInfo } from "@/api/index";
export default {
  data() {
    return {
      title: "",
      codeData: this.$route.params.data,
      infocontent: "",
    };
  },
  mounted() {
    console.log(this.codeData);
    this.title = this.codeData.title;
    this.init();
  },

  methods: {
    init() {
      var reqData = {
        xieYiCode: this.codeData.xieyiCode,
      };
      getXieYiInfo(reqData).then((res) => {
        if (res.data.state === 0) {
          this.infocontent = res.data.data.xieYiContent;
        }
      });
    },
  },
  components: {},
  computed: {},
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
/deep/.content-wrapper {
  font-size: 16px;
}
.recordBox {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  min-height: 100vh;
  background-color: rgb(246, 246, 246);
}
.contentbox {
  padding: 6px;
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  border-radius: 15px;
  background-color: #fff;
}
</style>
